import React from 'react';
import { LoadingAnimation } from 'kubra-ux/dist/foundation/LoadingAnimation';

const LoadingScreen = (): JSX.Element => (
  <div className={'loading-screen'}>
    <LoadingAnimation />
    <h1>Loading BGE Customers Restored Report...</h1>
  </div>
);

export default LoadingScreen;
